import React, { useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { TimeLeft } from './styles';
import { Props } from './models';

/**
 * A React component that displays a countdown timer.
 *
 * @param {boolean} isStart - Whether or not to start the countdown.
 * @param {(isStart: boolean) => void} onChange - A callback function that is called when the countdown starts or stops.
 * @param {number} timeMins - The number of minutes for the countdown.
 * @param {() => void} showResetButton - A callback function that is called when the countdown ends and a reset button should be shown.
 */
const TimeCounter = ({
  isStart,
  onChange,
  timeMins,
  showResetButton,
}: Props) => {
  const [time, setTime] = useState('');
  const [date, setDate] = useState<Dayjs>();

  useEffect(() => {
    /**
     * If the countdown should start, update the state and set a new date for the end of the countdown.
     */
    if (isStart) {
      onChange(false);
      setTime('');

      setDate(dayjs().add(timeMins, 'minutes'));
    }
  }, [isStart, timeMins]);

  useEffect(() => {
    /**
     * Create an interval that updates the time every second until the end of the countdown.
     */
    const myInterval = setInterval(() => {
      if (dayjs().isAfter(date)) {
        showResetButton && showResetButton();
        return;
      }

      const allSeconds = dayjs(date).diff(dayjs(), 'seconds');
      const minutes = Math.floor(allSeconds / 60);
      const seconds = allSeconds - 60 * minutes;

      setTime(`0${minutes}:${seconds < 10 ? '0' : ''}${seconds}`);
    }, 1000);

    /**
     * Clear the interval when the component unmounts.
     */
    return () => {
      clearInterval(myInterval);
    };
  }, [date]);

  return dayjs().isAfter(date) ? (
    <TimeLeft isEnded>00:00 min</TimeLeft>
  ) : (
    <TimeLeft>{time} min</TimeLeft>
  );
};

export default TimeCounter;
